// polyfills
import picturefill from 'picturefill';
// import objectFitPolyfill from 'objectFitPolyfill';

// pages & components
import navigation from './scripts/navigation';
import lazy from './scripts/lazyload';
import carousel from './scripts/carousel';
import designer from './scripts/designer';
import collection from './scripts/collection';

class App {
  constructor() {
    // navigation
    navigation.init();
    // lazy loader
    lazy.init();
    // carousels
    carousel.init();
    // designer collection landing
    designer.init();
    // collection
    collection.init();

    // polyfills
    // 'srcset' and <picture>
    picturefill();
    // object-fit
    // objectFitPolyfill();
  }
}

const app = new App();